@if (resource(); as resource) {
  @switch (resource.status()) {
    @case ('error') {
      <p>
        <mat-icon>error</mat-icon>
      </p>
      <p>Failed to load items.</p>
      <p>
        <button matButton="outlined" (click)="resource.reload()">Retry</button>
      </p>
    }
    @case ('resolved') {
      @if (resource.hasValue() && resource.value().items.length) {
        <ng-content />
      } @else {
        <p>
          <mat-icon>search_off</mat-icon>
        </p>
        <p>There are no items to display.</p>
        @if (!disableClear()) {
          <p>
            <a matButton="outlined" [routerLink]="[]">Clear filters and try again</a>
          </p>
        }
      }
    }
    @default {
      <p>
        <mat-icon>search</mat-icon>
      </p>
      <p>Loading, please wait...</p>
    }
  }
}
